"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignedSlot = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./SignatureSlot.css"));
var Esignature_1 = require("@CommonFrontendBackend/Accept/Esignature");
var SignatureSlot_1 = require("./SignatureSlot");
var classnames_1 = __importDefault(require("classnames"));
var typeToLabel = function (type) {
    switch (type) {
        case SignatureSlot_1.SlotType.Signature: {
            return "Signed";
        }
        case SignatureSlot_1.SlotType.Initials: {
            return "Initials";
        }
        default:
            return "Accepted";
    }
};
var SignedSlot = function (_a) {
    var data = _a.data, type = _a.type, dateStamp = _a.dateStamp, labelStyle = _a.labelStyle, name = _a.name, _b = _a.size, size = _b === void 0 ? "fit-content" : _b;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: (0, classnames_1.default)(["signature-slot", styles.gridContainer({ size: size })]) },
        type === "no-signature" ? (react_1.default.createElement(kaleidoscope_1.Stack, { padding: "s", className: styles.borderedContainer, align: "start", justify: "center" },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true, className: styles.textOverride }, name))) : (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.signatureImageContainer({ size: size }), align: "start", justify: "center" },
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.imageBackground, align: "start", justify: "center" },
                react_1.default.createElement("img", { className: styles.signatureImage, src: (0, Esignature_1.esignatureDataToDataUrl)(data), alt: "E-".concat(type === SignatureSlot_1.SlotType.Signature ? "Signature" : "Initials", " for ").concat(name) })))),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.prefix, direction: "horizontal" },
            react_1.default.createElement(kaleidoscope_1.Text, { className: styles.label, strong: true, size: "s" }, typeToLabel(type)),
            dateStamp && (react_1.default.createElement(kaleidoscope_1.Text, { className: styles.dateStamp, strong: true, size: "xs", secondary: true, "data-snapshot-ignore": "true" }, dateStamp))),
        labelStyle === "name" && (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.postfix({ size: size }), direction: "horizontal" },
            react_1.default.createElement(kaleidoscope_1.Text, { className: (0, classnames_1.default)(styles.label, styles.truncatedText), size: "s" }, name)))));
};
exports.SignedSlot = SignedSlot;
